import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import PersonalPage from "./sections/PersonalPage";
import Interests from "./sections/Interests";
import HighSchool from "./sections/HighSchool";
import UniversityOfMichigan from "./sections/UniversityOfMichigan";
import CaseStudies from "./sections/CaseStudies";
import Loyola from "./sections/Loyola";
import SocialMediaLinks from "./sections/SocialMediaLinks";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <PersonalPage />
      <Interests />
      <HighSchool />
      <UniversityOfMichigan />
      <CaseStudies />
      <Loyola />
      <SocialMediaLinks />
      <Footer />
    </div>;
}